






















/* General */
import Vue from 'vue'
import { Location } from 'vue-router'

/* Mixins */

/* Components */
import HomeTableListItemResponsive from './home-table-list-item-responsive.vue'
import { IHomeTableItem } from '@/types/data-objects/items'
import { HomeTableProps } from '@/components/listing/home-table/home-table.constants'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { EEntities } from '@/types'

/* API */

export default Vue.extend({
  name: 'HomeTableResponsive',

  components: {
    HomeTableListItemResponsive,
  },

  props: {
    ...HomeTableProps,
  },

  data() {
    return {
      itemsLoading: new Array(2).fill({}),
    }
  },

  computed: {
    itemsToDisplay(): IHomeTableItem[] {
      return this.isLoading ? this.itemsLoading : this.tableData
    },

    isMailbox(): boolean {
      return this.type === EEntities.MAILBOXES
    },

    isProject(): boolean {
      return this.type === EEntities.PROJECTS
    },
  },

  methods: {
    /**
     * Get a Route object to be used in router-link component
     * according to the object
     */
    getDetailRouterLink(row: IHomeTableItem): Location {
      if (this.isMailbox) {
        return RouteAssistant.getConversationRoute(
          this.$route.params.accountId,
          row.parent.id,
          row.id.toString(),
          row.parent.name,
          row.refNumber,
          row.title,
          null,
          this.fromAll,
          this.fromEntityHome,
        )
      } else {
        return RouteAssistant.getTaskRoute(
          this.$route.params.accountId,
          row.parent.id,
          row.id.toString(),
          this.$permissions,
          row.parent.name,
          row.refNumber,
          row.title,
          null,
          this.fromAll,
          this.fromEntityHome,
        )
      }
    },
  },
})
